import { useQuery } from '@tanstack/react-query';
import type { MeterBucket, ReadRateSlaByProductTypeResponse, RegisterBucket } from '@metron/shared';
import { useApiClient } from './useApiClient.ts';

export interface ProductTypeFilter {
  registerBuckets: Exclude<RegisterBucket, 'OtherRegister'>[];
  meterBuckets: MeterBucket[];
}

export function useReadRateSlaByProductType(filter: ProductTypeFilter) {
  const apiClient = useApiClient();
  const queryString = new URLSearchParams();
  if (filter.registerBuckets.length > 0) {
    queryString.set('registerType', filter.registerBuckets.join(','));
  }
  if (filter.meterBuckets.length > 0) {
    queryString.set('meterType', filter.meterBuckets.join(','));
  }
  const path = `read-rate-sla/by-product-type${
    queryString.size > 0 ? `?${queryString.toString()}` : ''
  }`;
  return useQuery({
    queryKey: ['read-rate-sla', 'by-product-type', filter],
    queryFn: () => apiClient.get<ReadRateSlaByProductTypeResponse>(path),
  });
}
